import { Grid, Header, Divider } from 'semantic-ui-react';
import { submit } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { has } from 'lodash';

import { AERIES_PREVIEW_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import 'Styles/pages/vendorlinkintegration/preview.less';

import * as actions from '../../state/actions';
import * as selectors from '../../state/selectors';
import { AeriesPreviewStepForm } from './AeriesPreviewForm';
import Spinner from '../../../vendorlinkintegration/components/LoadingComponents/CircularSpinner';
import * as Helpers from '../../../vendorlinkintegration/helpers/helper';

export class AeriesPreviewContainer extends Component {
  render() {
    const {
      handleKeyDown,
      onSubmit,
      loading,
      config,
      reducedData,
    } = this.props;

    return (
      <React.Fragment>
        <TitledCard title="Single Student Preview">
          <AeriesPreviewStepForm
            handleKeyDown={handleKeyDown}
            onSubmit={onSubmit}
            loading={loading}
          />
          {reducedData && !loading && (
            <React.Fragment>
              <Divider />
              <Grid className={'Aeries-preview'}>
                {reducedData.map((item) => {
                  return (
                    <Grid.Column width="4" key={item.key}>
                      <div
                        className={classNames(item.key, {
                          null:
                            has(item, 'value') &&
                            !item.value &&
                            Helpers.getItemValue(item, config) ===
                              '(No Data Available)',
                          skipped:
                            has(item, 'value') &&
                            Helpers.getItemValue(item, config) === '(Skipped)',
                        })}
                      >
                        <Header as="h5">{item.key}</Header>
                        {Helpers.getItemValue(item, config)}
                      </div>
                    </Grid.Column>
                  );
                })}
                <Grid.Row />
              </Grid>
            </React.Fragment>
          )}
          {loading && <Spinner />}
        </TitledCard>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  submit: () => submit(AERIES_PREVIEW_FORM_NAME),
  ...actions,
};

const mapStateToProps = (state) => {
  return {
    gradeOptions: selectors.getGradeOptions(state),
    siteOptions: selectors.getSiteOptions(state),
    languageOptions: selectors.getLanguageOptions(state),
    reducedData: selectors.getReducePreviewData(state),
  };
};

export const AeriesPreview = connect(
  mapStateToProps,
  mapDispatchToProps
)(AeriesPreviewContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesPreviewStep/AeriesPreview.js